export const productShortName = 'Underground Mining & Mine Operations — Professional Edition';
export const productBrand = 'Underground Mining & Mine Operations';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/9AVxkzXFUrkhW77tGB2nyp/MOCKUP_UNDERGROUND.png';
export const productImageAlt =
  'Underground Mining & Mine Operations Professional Edition: six volumes covering mine layout and access, mining methods, ground support, drilling and blasting, ventilation and services, and haulage and safety, plus five bonus resources';

export const checkoutUrl = 'https://underground-mining-mine-operations.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how an underground mine is laid out and accessed',
  'No more uncertainty about mining methods, stoping and fill',
  'No more gaps in understanding rock behaviour and ground support',
  'No more guessing about the drill-and-blast cycle and ventilation',
  'No more struggling to read mine plans, long sections and development drawings',
];
